import React from 'react';
import { FDBox, FDDialog } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useComponentDidMount from 'Hooks/useComponentDidMount';
import useMobileLayout from 'Hooks/useMobileLayout';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';

const useStyles = buildUseStyles('CapitalizeIFrameModal', () => ({
  iframe: {
    border: 'none',
    width: '100%',
    height: ({ isMobile }) => (isMobile ? '100vh' : '90vh'),
  },
}));

const CapitalizeIFrameModal = ({ open, rel, onClose }) => {
  const isMobile = useMobileLayout();
  const { refreshPageContentCollection } = usePageContentContext();

  const classes = useStyles({ isMobile });

  const handleClose = (event) => {
    if (event?.data?.onCapitalizeExit) {
      onClose();
      refreshPageContentCollection();
    }
  };

  useComponentDidMount(() => window.addEventListener('message', handleClose), () => window.removeEventListener('message', handleClose));

  return (
    <FDDialog
      open={open}
      onClose={onClose}
      dialogWidth={isMobile ? undefined : 'sm'}
      closeOnBackdropClick
      fullScreen={isMobile}
      variant="modern"
    >
      <FDBox flexGrow={1}>
        <iframe
          id="iframe"
          title="iframe"
          src={rel.link('related').url()}
          className={classes.iframe}
        />
      </FDBox>
    </FDDialog>
  );
};

CapitalizeIFrameModal.defaultProps = {
};

CapitalizeIFrameModal.propTypes = {
  rel: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CapitalizeIFrameModal;
